// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicWebV1SearchOffersForNewbuildingPromosRequest,
  TPublicWebV1SearchOffersForNewbuildingPromosModel,
  IMappers,
  TPublicWebV1SearchOffersForNewbuildingPromosResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetOffersForPromoPageDesktopResponseSchema } from '../../../entities/entities/GetOffersForPromoPageDesktopResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1SearchOffersForNewbuildingPromosModel(
  parameters: TPublicWebV1SearchOffersForNewbuildingPromosRequest,
): TPublicWebV1SearchOffersForNewbuildingPromosModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers',
    pathApi: '/web/v1/search-offers-for-newbuilding-promos/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicWebV1SearchOffersForNewbuildingPromosOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicWebV1SearchOffersForNewbuildingPromosRequest;
}

export async function fetchPublicWebV1SearchOffersForNewbuildingPromos<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicWebV1SearchOffersForNewbuildingPromosOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1SearchOffersForNewbuildingPromosResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1SearchOffersForNewbuildingPromosModel(parameters),
    config,
  )) as FetchResponse<TPublicWebV1SearchOffersForNewbuildingPromosResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOffersForPromoPageDesktopResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1SearchOffersForNewbuildingPromosResponse>;
}
